import massesActions from './massesActions';

export default {
  ...massesActions,
};
